import {Tabs} from "@mantine/core";
import "./CourseTab.css";
import CourseScheduleAccordion from "../CourseScheduleAccordion/CourseScheduleAccordion";
import CourseReviewsCard from "../CourseReviews/CourseReviewsCard/CourseReviewsCard";
import CourseProfessorInfo from "../CourseProfessorInfo/CourseProfessorInfo/CourseProfessorInfo";

const CourseTab = ({modules, staff, reviews, courseTabs}) => {
const {firstTab, secondTab, thirdTab} = courseTabs;

    return (
        <div className="courseTab-tabs-div-container">
            <Tabs
                defaultValue="programa"
                classNames={{
                    root: "courseTab-root-tabs",
                    tabLabel: "courseTab-tabLabel-tabs",
                }}
            >
                <Tabs.List grow>
                    <Tabs.Tab value="programa">{firstTab}</Tabs.Tab>
                    <Tabs.Tab value="profesores">{secondTab.title}</Tabs.Tab>
                    <Tabs.Tab value="valoraciones">{thirdTab.title}</Tabs.Tab>
                </Tabs.List>

                <Tabs.Panel value="programa">
                    <CourseScheduleAccordion modules={modules}/>
                </Tabs.Panel>

                <Tabs.Panel value="profesores">
                    <CourseProfessorInfo secondTabLegend={secondTab.emptyStaffLegend} staff={staff}/>
                </Tabs.Panel>
                <Tabs.Panel value="valoraciones">
                    <CourseReviewsCard thirdTabLegend={thirdTab.emptyValorationsLegend} reviews={reviews}/>
                </Tabs.Panel>
            </Tabs>
        </div>
    );
};

export default CourseTab;
